import { FormBuilder, Validators } from '@angular/forms';
import { Examen } from '../Examen.config';
import { apellidoNombreTrabajadorValidator } from '../../../../../utils/apellido-nombre-trabajador-validator';

export class EstudioCuestionarioDireccionadoMMSS extends Examen {
  id = 8;
  code = 'PFYGR';
  name = 'ESTUDIO CUESTIONARIO DIRECCIONADO MMSS';
  baseUrl = 'estudios/carga';
  isAttachedFileRequire = false;
  sections = [
    {
      name: 'ESTUDIO CUESTIONARIO DIRECCIONADO MMSS',
      fields: {
        fechaRealizacion: [ '', [ Validators.required ] ],
      },
    },
    {
      name: 'Empleador',
      fields: {},
      numberForm: 1,
    },
    {
      name: 'Trabajador',
      fields: {
        apellidoNombre:['', [Validators.required, Validators.maxLength(100), apellidoNombreTrabajadorValidator]],
        fechaNacimiento: ['', [Validators.required]],    
        puestoTrabajador: ['', [Validators.required]],
        fechaIngresoEmpresa: ['', [Validators.required]],
        antiguedadPuestoTrabajador: ['', [Validators.required]],
      },
      numberForm: 2,
    },
    {
      name: 'DescripcionBreveTrabajoHabitual',
      fields: {
        desTrabHab: ['', [Validators.required, Validators.maxLength(1000)]],
      },
      numberForm: 3,
    },
    {
      name: 'AntecedentesLaboralesMismaActividad',
      fields: {
        antLaboral: [ false ],
				antLaboralSi: [ false ],
				antLaboralNo: [ true ],
				desAntLaboral: [ { value: '', disabled: true } ],
      },
      numberForm: 4,
    },
    {
      name: 'TiempoDeTarea',
      fields: {
        tiempoHoras: [ '', [ Validators.required, Validators.maxLength(3) ] ],
				tiempoSemanas: [ '', [ Validators.required, Validators.maxLength(3) ] ],
				tiempoTarea: [null, [ Validators.required]]
      },
      numberForm: 5,
    },
    {
      name: 'ManipulacionCarga',
      fields: {
        manipulacionCarga: [null, [ Validators.required]]
      },
      numberForm: 6,
    },
    {
      name: 'CicloTrabajo',
      fields: {
        cicloTrabajo: [null, [ Validators.required]]
      },
      numberForm: 7,
    },
    {
      name: 'TipoDeTarea',
      fields: {
        tipoMovHombro: [ null ],
        tipoMovHombroSi: [ false ],
        tipoMovHombroNo: [ false ],
        tipoMovMuneca: [ null ],
        tipoMovMunecaSi: [ false ],
        tipoMovMunecaNo: [ false ],
        tipoMovNervio: [ null ],
        tipoMovNervioSi: [ false ],
        tipoMovNervioNo: [ false ],
        tipoMovCubitales: [ null ],
        tipoMovCubitalesSi: [ false ],
        tipoMovCubitalesNo: [ false ],
        tipoOtro: [ null ],
        tipoOtroSi: [ false ],
        tipoOtroNo: [ false ],
        descTipoOtro: [ { value: '', disabled: true } ],
        tipoCuello: [ null ],
        tipoCuelloSi: [ false ],
        tipoCuelloNo: [ false ],
        tipoColumna: [ null ],
        tipoColumnaSi: [ false ],
        tipoColumnaNo: [ false ],
        tipoRotAntebrazo: [ null ],
        tipoRotAntebrazoSi: [ false ],
        tipoRotAntebrazoNo: [ false ],
        tipoFlexCodo: [ null ],
        tipoFlexCodoSi: [ false ],
        tipoFlexCodoNo: [ false ],
        tipoFlexDedo: [ null ],
        tipoFlexDedoSi: [ false ],
        tipoFlexDedoNo: [ false ],
      },
      numberForm: 8,
    },
    {
      name: 'HerramientasElementosUtilizaDiario',
      fields: {
        cicloDescHerramientas: ['', [Validators.maxLength(1000)]],
      },
      numberForm: 9,
    },
    {
      name: 'TurnosDeTrabajo',
      fields: {
        cicloTurnoTrab: ['', [Validators.maxLength(1000)]],
      },
      numberForm: 10,
    },
    {
      name: 'PausasTrabajo',
      fields: {
        cicloPausaTrab: ['', [Validators.maxLength(1000)]],
      },
      numberForm: 11,
    },
    {
      name: 'FlexionColumna',
      fields: {
        flexionSostenidaCol: [ false ],
				flexionSostenidaColSi: [ false ],
				flexionSostenidaColNo: [ true ],
      },
      numberForm: 12,
    },
    {
      name: 'MovilidadDolor',
      fields: {
        sinParticularidades: [ true ],
				miembrosSuperiores: [ false ],
				miembrosInferiores: [ false ],
      },
      numberForm: 13,
    },
    {
      name: 'Articulaciones',
      fields: {
        tipoCaracterizacionSemiologicaMMSS: [ '' ],
        dolorAgudoMmss: [ false ],
        dolorInsidiosoMmss: [ false ],
        cursoContinuoMmss: [ false ],
        cursoBrotesMmss: [ false ],
        cursoCiclicoMmss: [ false ],
        tipoCaracterizacionSemiologicaMMII: [ '' ],
        dolorAgudoMmii: [ false ],
        dolorInsidiosoMmii: [ false ],
        cursoContinuoMmii: [ false ],
        cursoBrotesMmii: [ false ],
        cursoCiclicoMmii: [ false ],
      },
      numberForm: 14,
    },
    {
      name: 'Observaciones',
      fields: {
        obsMed: ['', [Validators.maxLength(1000)]]
      },
      numberForm: 15,
    },
    {
      name: 'Dictamen medico',
      fields: {
        medicoNombre: [ null, [ Validators.required, Validators.pattern( /^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]+$/ ) ]],
        codigoDictamen: [ null, [ Validators.required ]],
        medicoMatricula: [ null, [ Validators.required ]],
        medicoEspecialidad: [ null, [ Validators.required ]],
      },
      numberForm: 16,
    },
    {
      name: 'Adjuntos',
      fields: {},
      numberForm: 17,
    },
    {
      name: 'Semiología del segmento corporal comprometido',
      fields: {},
    },
    {
      name: 'Segmento Superior',
      fields: {},
    },
    {
      name: 'Segmento Inferior',
      fields: {},
    },
    {
      name: 'Segmento tabla',
      fields: {
      },
    },
    {
      name: 'Evaluacion clinica final',
      fields: {
      },
    },
  ];
  configTableSegmentoMMSS = [
    {
      name: 'Hombro',
      articulacion: 'hombro',
      der: new FieldTable(),
      izq: new FieldTable(),
    },
    {
      name: 'Codo',
      articulacion: 'codo',
      der: new FieldTable(),
      izq: new FieldTable(),
    },
    {
      name: 'Muñeca',
      articulacion: 'munieca',
      der: new FieldTable(),
      izq: new FieldTable(),
    },
    {
      name: 'Mano y dedos',
      articulacion: 'manoDedos',
      der: new FieldTable(),
      izq: new FieldTable(),
    },
  ];
  configTableSegmentoMMII = [
    {
      name: 'Cadera',
      articulacion: 'cadera',
      der: new FieldTable(),
      izq: new FieldTable(),
    },
    {
      name: 'Rodilla',
      articulacion: 'rodilla',
      der: new FieldTable(),
      izq: new FieldTable(),
    },
    {
      name: 'Tobillo',
      articulacion: 'tobillo',
      der: new FieldTable(),
      izq: new FieldTable(),
    },
  ];

  constructor(formBuilder: FormBuilder) {
    super(formBuilder);
    this.fieldList = this.getFields();
    this.examForm = this.getForm();
    this.sectionsList = this.getSections();
  }
}

export class FieldTable {
  abduccion: string;
  aduccion: string;
  flexion: string;
  extencion: string;
  rotacionExterna: string;
  rotacionInterna: string;
  irradiacion: string;
  alteracionMasaMuscular: string;

  constructor() {
    this.abduccion = 'Normal';
    this.aduccion = 'Normal';
    this.flexion = 'Normal';
    this.extencion = 'Normal';
    this.rotacionExterna = 'Normal';
    this.rotacionInterna = 'Normal';
    this.irradiacion = 'Normal';
    this.alteracionMasaMuscular = 'Normal';
  }
}
